<app-store-navigation></app-store-navigation>
@if (weekId) {
  <app-rota-week-data
    [weekId]="weekId"
    [showLinks]="true">
  </app-rota-week-data>
}